import { LicenseModuleEnum } from "../License/LicenseModuleEnum";
import { LoginMode } from "./LoginMode";

export class Organization {
    id: number;
    name: string;
    folderId: number;
    loginModes: LoginMode[];
    licensesData: OrganizationLicensesData;
    installationsCount: number;

    constructor() {}

    parse(obj: any) {
        this.id = obj.Id;
        this.name = obj.Name;
        this.folderId = obj.FolderId;
        if (obj.LoginModes != null && obj.LoginModes.length > 0) {
            this.loginModes = [];
            obj.LoginModes.forEach((element) => {
                var tempLoginMode = new LoginMode();
                tempLoginMode.parse(element);
                this.loginModes.push(tempLoginMode);
            });
        }
        if (obj.LicensesData != null) {
            this.licensesData = new OrganizationLicensesData();
            this.licensesData.parse(obj.LicensesData);
        }
        this.installationsCount = obj.InstallationsCount;
    }
}

export class OrganizationLicensesData {
    licensesByModule: { key: LicenseModuleEnum; value: number }[] = [];
    assignedLicensesByModule: { key: LicenseModuleEnum; value: number }[] = [];
    expirationDate: string;
    lastUpdateUTC: Date;

    constructor() {}

    parse(obj: any) {
        for (let key in obj.LicensesByModule) this.licensesByModule.push({ key: LicenseModuleEnum[key], value: obj.LicensesByModule[key] });
        for (let key in obj.AssignedLicensesByModule) this.assignedLicensesByModule.push({ key: LicenseModuleEnum[key], value: obj.AssignedLicensesByModule[key] });

        if (obj.ExpirationDate)
            this.expirationDate =
                new Date(obj.ExpirationDate).getFullYear() +
                "-" +
                (new Date(obj.ExpirationDate).getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                new Date(obj.ExpirationDate).getDate().toString().padStart(2, "0");
        if (obj.LastUpdateUTC) this.lastUpdateUTC = new Date(obj.LastUpdateUTC);
    }
}
